export default "__VITE_ASSET__96170770__"